import IconWithPopover from '@components/IconWithPopover/IconWithPopover'
import { MarketBasketWithSettings } from '@domain'
import { Chip, Link, Skeleton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { titleCase } from 'title-case'

export type BasketInfoProps = {
	isLoading: boolean
	marketBasket: MarketBasketWithSettings
	marketSegments: SimpleListItem[]
}

export function BasketInfo({ isLoading, marketBasket, marketSegments }: BasketInfoProps) {
	const theme = useTheme()
	const largeScreen = useMediaQuery(theme.breakpoints.up('xl'))

	if (isLoading)
		return (
			<Stack direction="row" gap={3}>
				<Skeleton width="10rem" />
				<Skeleton width="10rem" />
				<Skeleton width="5rem" />
				<Skeleton width="5rem" />
			</Stack>
		)

	const chips = (
		<>
			<Chip
				size="small"
				label={titleCase(marketBasket.basketType.toLowerCase())}
				data-testid="basket-type"
			/>
			<Chip size="small" label={titleCase(marketBasket.settings.tier)} data-testid="basket-type" />
			<Chip
				size="small"
				label={`Ann Period: ${marketBasket.settings.annualizationMonths} mons`}
				data-testid="annualization"
			/>
			{marketBasket.marketSegment && (
				<Chip
					size="small"
					color="error"
					label={`Mkt Seg: ${
						marketSegments.find((segment) => segment.id === marketBasket.marketSegment)?.label
					}`}
					data-testid="market-segment"
				/>
			)}
		</>
	)

	return (
		<Stack gap={2} direction="row" alignItems="center">
			<Stack direction="row" gap={0.5}>
				<Typography noWrap variant="h6">
					SF Case:
				</Typography>
				{marketBasket.salesforceCaseId ? (
					<Link href={marketBasket.caseIdLink} target="_blank" data-testid="case-id">
						<Typography variant="h6">{marketBasket.salesforceCaseNumber}</Typography>
					</Link>
				) : (
					<Typography variant="h6">{marketBasket.salesforceCaseNumber || 'N/A'}</Typography>
				)}
			</Stack>

			{largeScreen ? (
				<Stack direction="row" gap={1}>
					{chips}
				</Stack>
			) : (
				<IconWithPopover
					paperSx={{
						backgroundColor: theme.palette.background.paper,
						border: `1px solid ${theme.palette.divider}`,
					}}
				>
					<Stack p={1} gap={1}>
						{chips}
					</Stack>
				</IconWithPopover>
			)}
		</Stack>
	)
}
